import {useState} from 'react'
import LotCreationForm from './LotCreationForm';
import LotCreationListview from './LotCreationListview';

const LotCreation = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");
  
    return (
      <>
        {fromIsShown ? (
          <LotCreationForm addForm={setFromIsShown} update={upData}  sId={serviceId} />
        ) : (
          <LotCreationListview addForm={setFromIsShown} update={setUpData}  sId={setServiceId} />
        )}
      </>
  )
}

export default LotCreation